import { render, staticRenderFns } from "./tableContainer.vue?vue&type=template&id=55fbe6a2&scoped=true"
import script from "./tableContainer.vue?vue&type=script&lang=js"
export * from "./tableContainer.vue?vue&type=script&lang=js"
import style0 from "./tableContainer.vue?vue&type=style&index=0&id=55fbe6a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fbe6a2",
  null
  
)

export default component.exports